<template>
    <div>
        <div class="flex-end">
        <button class="btn pointer" v-if="isFactoryAdmin || isFactorySupervisor" @click="addUserModalObject.open = true">+ Add User</button>
        </div>
        <div class="copy-dtx-table mt-3">
            <table>
                <thead>
                    <tr>
                        <th>No.</th>
                        <th>Name</th>
                        <th>Role</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th v-if="isFactoryAdmin || isFactorySupervisor">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, index) in paginatedUsers" :key="row.id">
                        <td>{{ (pageNumber - 1) * perPage + index + 1 + ")" }}</td>
                        <td class="elipsis-text user-group-name" v-overflow-tooltip="row.name">{{ row.name }}</td>
                        <td class="elipsis-text description" v-overflow-tooltip="row.role">{{ config.USER_ROLE_INVERTED_MAP[row.role] }}</td>
                        <td class="elipsis-text email" v-overflow-tooltip="row.email">{{ row.email }}</td>
                        <td class="elipsis-text phone" v-overflow-tooltip="row.phone">{{ row.phone  ?? '--'}}</td>
                        <td v-if="isFactoryAdmin || isFactorySupervisor">
                          <span
                          :class="{disabled: !canEdit(row)}"
                          class="pointer mr-2"
                          v-tooltip="'Edit role'"
                           @click="openEditModal(row)">
                            <img width="20" src="~@/assets/images/pencil.svg"/>
                          </span>
                          <span
                          class="pointer"
                          v-tooltip="'Remove user'"
                          :class="{disabled: !canRemove(row)}"
                          @click="removeUser(row)">
                          <img width="20" src="~@/assets/images/trash-2.svg"/>
                        </span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="pagination-footer space-between">
                <pagination class="mt-4" :length="totalCount" :pageNumber="pageNumber" :perPage="perPage"
                    @selectPage="selectPage" v-if="totalCount>perPage"/>
                <span class="pagination-footer-total mt-4" v-if="users.length > 0">Total Users : &nbsp; <b>
                        {{ totalCount }}</b></span>
            </div>
        </div>
        <modal :open="addUserModalObject.open"
        @close="closeModal"
        :title="addUserModalObject.mode === 'create' ? 'Add User to ' + currentFactory.name : 'Edit User Role'">
        <add-user v-if="addUserModalObject.open"
        :factoryUsers="users"
        @userAdded="handleUserAdded"
        @changeRole="handleChangeRole"
        :selectedUserToEdit="selectedUserToEdit"
        :mode="addUserModalObject.mode"
        @cancel="closeModal"/>
        </modal>
    </div>
</template>

<script>
import Pagination from '@/components/common/pagination2.vue'
import Modal from '@/components/common/modal.vue'
import AddUser from './addUser.vue'
import { mapGetters } from 'vuex'
import Config from '@/config.js'
import { AddUserToFactory, ChangeUserRole, RemoveUserFromFactory } from '@/api'
import { alert, success } from '@/plugins/notification'
import confirmationDialog from '@/plugins/confirmationDialog'
import Loader from '@/plugins/loader'
export default {
  name: 'factory-users',
  components: {
    Pagination,
    Modal,
    AddUser
  },
  data () {
    return {
      users: [],
      totalCount: 0,
      pageNumber: 1,
      perPage: 5,
      config: Config,
      selectedUserToEdit: null,
      addUserModalObject: {
        open: false,
        mode: 'create'
      }
    }
  },
  computed: {
    ...mapGetters(['currentFactory', 'isFactoryAdmin', 'isFactorySupervisor', 'isTenantAdmin']),
    paginatedUsers () {
      const start = (this.pageNumber - 1) * this.perPage
      const end = start + this.perPage
      return this.users.slice(start, end)
    },
    supervisorCount () {
      return this.users.filter(
        u => u.role === this.config.USER_ROLE_MAP.SUPERVISOR
      ).length
    }
  },
  created () {
    this.init()
  },
  methods: {
    canEdit (user) {
      if (user.systemAdded) return false
      if (user.role === this.config.USER_ROLE_MAP.SUPERVISOR && this.supervisorCount <= 1) {
        return false
      }
      if (this.isTenantAdmin) {
        return true
      }
      if (this.isFactoryAdmin && user.role !== Config.USER_ROLE_MAP.ADMIN) {
        return true
      }
      if (this.isFactorySupervisor && !(user.role === Config.USER_ROLE_MAP.ADMIN || user.role === Config.USER_ROLE_MAP.SUPERVISOR)) {
        return true
      }
      return false
    },
    canRemove (user) {
      if (user.systemAdded) return false
      if (user.role === this.config.USER_ROLE_MAP.SUPERVISOR && this.supervisorCount <= 1) {
        return false
      }
      if (this.isTenantAdmin && !user.systemAdded) {
        return true
      }
      if (this.isFactoryAdmin && user.role !== Config.USER_ROLE_MAP.ADMIN) {
        return true
      }
      if (this.isFactorySupervisor && !(user.role === Config.USER_ROLE_MAP.ADMIN || user.role === Config.USER_ROLE_MAP.SUPERVISOR)) {
        return true
      }
      return false
    },
    selectPage (page) { this.pageNumber = page },
    handleUserAdded (obj) {
      const loader = new Loader()
      loader.show()
      AddUserToFactory(obj.userId, obj.roleId).then((res) => {
        const factoryObject = JSON.parse(JSON.stringify(this.currentFactory))
        factoryObject.project_user_associations.push(res.insert_project_user_association_one)
        loader.hide()
        this.$store.commit('setCurrentFactory', factoryObject)
        this.init()
        this.closeModal()
        success('User added successfully!')
      }).catch(() => {
        loader.hide()
        alert('Unable to add user to factory. Please try again.')
      })
    },
    handleChangeRole (obj) {
      const loader = new Loader()
      loader.show()
      ChangeUserRole(obj.userId, obj.roleId).then((res) => {
        const factoryObject = JSON.parse(JSON.stringify(this.currentFactory))
        for (const user of factoryObject.project_user_associations) {
          if (user.user_id === obj.userId) {
            user.role_id = obj.roleId
            break
          }
        }
        this.$store.commit('setCurrentFactory', factoryObject)
        this.init()
        this.closeModal()
        loader.hide()
        success('User role changed successfully!')
      }).catch(() => {
        loader.hide()
        alert('Unable to change role')
      })
    },
    closeModal () {
      this.addUserModalObject = {
        open: false,
        mode: 'create'
      }
    },
    openEditModal (user) {
      this.selectedUserToEdit = user
      this.addUserModalObject = {
        open: true,
        mode: 'edit'
      }
    },
    removeUser (user) {
      const id = user.id
      confirmationDialog(
        'Are you sure you want to remove this user?',
        (res) => {
          if (res) {
            const loader = new Loader()
            loader.show()
            const useFactoryToken = true
            RemoveUserFromFactory([id], useFactoryToken).then((res) => {
              const factoryObject = JSON.parse(JSON.stringify(this.currentFactory))
              factoryObject.project_user_associations = factoryObject.project_user_associations.filter((item) => item.user_id !== id)
              loader.hide()
              this.$store.commit('setCurrentFactory', factoryObject)
              success('User removed successfully!')
              this.init()
            }).catch(() => {
              loader.hide()
              alert('Unable to remove user')
            })
          }
        }
      )
    },
    init () {
      this.users = this.currentFactory?.project_user_associations?.map(association => {
        return {
          id: association?.associated_user?.id,
          name: association?.associated_user?.first_name + ' ' + association?.associated_user?.last_name,
          role: association?.role_id,
          email: association?.associated_user?.email,
          phone: association?.associated_user?.phone,
          systemAdded: association?.system_added ?? false
        }
      })
      this.totalCount = this.users.length
      const maxPage = Math.ceil(this.totalCount / this.perPage) || 1
      if (this.pageNumber > maxPage) {
        this.pageNumber = maxPage
      }
    }
  }
}
</script>

<style lang="scss" scoped>

  .disabled {
    pointer-events: none;
    opacity: 0.5;
    cursor: not-allowed;
  }

</style>
